import React, { useCallback, useState } from "react";
import { Button, Card } from "antd";

import { useAppDispatch } from "store";
import {
  createOfferRecommendationAction,
  deleteOfferRecommendationAction,
  editOfferRecommendationAction,
  loadOfferRecommendationsAction,
} from "store/recommendations/recommendations.actions";
import useListData, { LoadListDataParams } from "hooks/useListData";
import { OfferModal } from "./OfferModal";
import { OffersTable } from "./OffersTable";
import { IOfferRecommendation } from "types/recommendations.types";
import { getUTCDate } from "utils/date";

export const Offers = () => {
  const dispatch = useAppDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [editEntity, setEditEntity] = useState<IOfferRecommendation>();

  const handleShowModal = () => {
    setOpenModal(true);
  };
  const handleHideModal = () => {
    setOpenModal(false);
  };

  const handleListLoad = useCallback((params: LoadListDataParams) => {
    return dispatch(loadOfferRecommendationsAction(params));
  }, []);
  const { items, loading, loadData, pagination, onTableChange } =
    useListData(handleListLoad);
  const reloadListData = useCallback(() => {
    return loadData({
      page: pagination.current,
      pageSize: pagination.pageSize,
    });
  }, [loadData, pagination]);

  const handleSubmit = async ({ icon, ...rest }: any) => {
    const data = {
      ...rest,
      icon: "/icons/" + icon?.[0]?.id,
    };
    if (rest.workTimeInterval) {
      data.workTimeInterval = {
        from: getUTCDate(rest.workTimeInterval?.from),
        to: getUTCDate(rest.workTimeInterval?.to),
      };
    }

    await dispatch(createOfferRecommendationAction(data));

    handleHideModal();
    reloadListData();
  };
  const handleEditClick = (value: IOfferRecommendation) => {
    setEditEntity(value);
  };
  const handleEditHide = () => {
    setEditEntity(undefined);
  };
  const handleEdit = async (id: number, { icon, ...rest }: any) => {
    await dispatch(
      editOfferRecommendationAction({
        id,
        values: {
          ...rest,
          icon: "/icons/" + icon?.[0]?.id,
        },
      })
    );
    handleEditHide();
    return reloadListData();
  };
  const handleDelete = async (value: IOfferRecommendation) => {
    await dispatch(deleteOfferRecommendationAction({ id: value.id }));
    return reloadListData();
  };
  return (
    <>
      <Card
        title="Настроенные рекомендации"
        extra={
          <Button type="primary" onClick={handleShowModal}>
            Добавить
          </Button>
        }
      >
        <OffersTable
          items={items}
          loading={loading}
          onChange={onTableChange}
          pagination={pagination}
          onEdit={handleEditClick}
          onDelete={handleDelete}
        />
      </Card>
      {!!editEntity && (
        <OfferModal
          visible={!!editEntity}
          onClose={handleEditHide}
          citiesDisabled={false}
          initialValues={{
            ...editEntity,
            icon: [
              { ...editEntity?.icon, thumbUrl: editEntity?.icon?.filePath },
            ],
            age: editEntity?.age || undefined,
          }}
          onSubmit={(values) => handleEdit(editEntity.id, values)}
        />
      )}
      <OfferModal
        visible={openModal}
        onClose={handleHideModal}
        onSubmit={handleSubmit}
      />
    </>
  );
};
